export const EShapeActionValueOpenDialogType = wcardinal.ui.EShapeActionValueOpenDialogType;